export enum AddOnCode {
  Optimize = 'optimize',
  Photo = 'photo',
  Video = 'video'
}
